<template>
  <section>    
    <BodyText :body="message.body"></BodyText>
    <div v-if="message.attachments.length != 0">
      <hr class="pb-0 mb-0 mt-2" />

      <div class="info-header mt-2">{{ $t("ATTACHMENTS") }}</div>

      <span v-for="(item, index) in message.attachments" :key="index">
        <Attachment
          :item="item"
          :message_uuid="message.message_uuid"
          :user_uuid="user_uuid"
          :functionbox_uuid="functionbox_uuid"
          :index="index"
        ></Attachment>
      </span>
    </div>

    <hr class="pb-0 mb-0 mt-2" />
    <MetadataFax class="clearfix mt-2"  v-if="message.creator.external_system" :metadata="message.creator.external_system.metadata"></MetadataFax>
  </section>
</template>
<script>
import Attachment from "@/components/View/Attachment";
import BodyText from "@/components/View/BodyText";
import MetadataFax from "@/components/View/Information/Metadata/FaxMetadata";
export default {
  name: "MessageInformation",
  props: ["message", "metadata","user_uuid", "functionbox_uuid"],
  components: {
    Attachment,
    MetadataFax,
    BodyText
  },
  data() {
    return {
    };
  },
  methods: {
  },
  watch: {},
  mounted: function () {},
};
</script>
<style></style>
